const STYLES_CONFIG = {
  color: {
    base: "#181818",
    dark:  "#232323",
    primary: "#0078D7",
    muted: "#2E4A45",
    low: "#50BB9B",
    warning: "#F3B433",
    danger: "#D34D3F",
  },
  spacing: {
    _1: "0.25rem",
    _2: "0.5rem",
    _3: "0.75rem",
    _4: "1rem",
    
    _5: "1.25rem",
    _6: "1.5rem",
    _7: "1.75rem",
    _8: "2rem",
  },
  font: {
    size: {
      _1: "0.625rem", 
      _2: "0.688rem",
      _3: "0.75rem",
      _4: "0.813rem",
      _5: "0.875rem",
      _6: "0.938rem",
      _7: "1rem",
      _8: "1.125rem",
      _9: "1.25rem",
      _10: "1.5rem",
      _11: "2rem",
      _12: "2.25rem",
      _13: "2.5rem",
      _14: "3rem",
      _15: "4rem",
      _16: "6rem",
      _17: "8rem",
    }
  }
};

export default STYLES_CONFIG;
